<template>
    <div
            style="align-items: flex-start;background:white;max-width: 500px;padding-top: 30px;padding-bottom: 60px;margin: 50px auto;min-height:100px;"
            :class="{ 'tp-payment': true }"
    >
        <div class="tp-payment-container">
            <div v-if="loading" class="loader">
                <div class="loader-animation">&nbsp;</div>
            </div>
            <div v-else>
                <div>
                    <div class="tp-payment-head">
                        <ul class="tp-payment-lang">
                            <li :class="{ active: locale === 'et_EE' }" @click="switchLang('et_EE')">
                                <a href="javascript:{}">EST</a>
                            </li>
                            <li :class="{ active: locale === 'en_GB' }" @click="switchLang('en_GB')">
                                <a href="javascript:{}">ENG</a>
                            </li>
                            <li :class="{ active: locale === 'ru_RU' }" @click="switchLang('ru_RU')">
                                <a href="javascript:{}">RUS</a>
                            </li>
                            <li :class="{ active: locale === 'lv_LV' }" @click="switchLang('lv_LV')">
                                <a href="javascript:{}">LVA</a>
                            </li>
                            <li :class="{ active: locale === 'lt_LT' }" @click="switchLang('lt_LT')">
                                <a href="javascript:{}">LTU</a>
                            </li>
                        </ul>
                        <div class="tp-payment-brand">
                            <label>
                                {{ t("Payment service provided by") }}
                            </label>
                            <img :src="assets_url + '/img/tarkpay-logo.png'"/>
                        </div>
                    </div>
                </div>
                <div class="tp-payment-content" style="text-align: center;">
                    <div v-if="success && accounts.length > 0">
                        <h1 class="bank-name-header mb-3" v-if="bankName">{{ bankName }}</h1>
                        <p class="intro-text mb-4">{{
                                t('Please select accounts which you want to give consent to')
                            }}:</p>
                        <div class="account-select-container">
                            <v-checkbox v-for="account in accounts" :key="`account_${account.id}`"
                                        v-model="account.is_selected" :label="getAccountName(account)"
                                        color="#4A5995"></v-checkbox>
                        </div>

                    </div>
                    <p v-else>{{ t("Something went wrong doing action") }}</p>
                </div>
                <div class="tp-payment-foot">
                    <button
                            class="button-redirect ma-0"
                            type="button"
                            @click="handleContinueClick"
                    >
                        {{ t('Continue') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import settings from "../settings";
import axios from "axios";

export default {
    name: "account-select-view",
    data() {
        return {
            assets_url: settings.assets_url,
            success: 0,
            accounts: [],
            bankName: null,
            companyBankId: null,
            locale: 'et_EE',
            translations: [],
            loading: true,
        };
    },
    async mounted() {
        await this.fetchTranslations(this.locale);
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);

        if (params.get("state")) {
            await this.fetchAccounts(params.get("state"));
        } else {
            this.success = 0;
        }
    },
    methods: {
        sendToProvider() {
            window.location = this.redirectUrl;
        },
        switchLang(locale) {
            this.fetchTranslations(locale);
        },
        async fetchAccounts(state) {
            this.loading = true;
            try {
                const response = await axios.get(`${process.env.VUE_APP_AS_API_URL}/app/psd2/ais/select-accounts/`, {params: {state}});

                if (response.data && response.data.success === 1) {
                    this.accounts = response.data.accounts;
                    this.bankName = response.data.bank_name;
                    this.companyBankId = response.data.company_bank_id;
                    this.success = 1;
                    this.loading = false;
                } else {
                    this.success = 0;
                    this.loading = false;
                }
            } catch (e) {
                this.success = 0;
                console.error(e)
            }
        },
        async fetchTranslations(locale) {
            let url = settings.assets_url + "/translations/" + locale + ".json";
            let results = await axios.get(url, {withCredentials: false, headers: {}});
            this.locale = locale;
            this.translations = results.data
        },
        async handleContinueClick() {
            const selectedAccountsIds = this.accounts.filter(a => a.is_selected).map(a => a.id)

            if (selectedAccountsIds.length === 0) {
                console.log("No accounts selected")
                return
            }

            this.loading = true;

            const payload = {
                bankName: this.bankName,
                selectedAccountsIds
            }

            try {
                const response = await axios.post(`${process.env.VUE_APP_AS_API_URL}/app/psd2/ais/select-accounts/`, payload, {params: {state: this.companyBankId}});

                if (response.data && response.data.success === 1) {
                    if (response.data.redirect_url) {
                        window.location = response.data.redirect_url;
                        return;
                    }
                } else {
                    this.success = 0;
                }
            } catch (e) {
                this.success = 0;
                console.error(e)
            }
            this.loading = false;
        },

        t(key) {
            if (this.translations && this.translations[key]) {
                return this.translations[key];
            }
            return key;
        },

        getAccountName(account) {
            let name = '';
            if (account.name) {
                name += `${account.name} `
            } else if (account.owner_name) {
                name += `${account.owner_name} `
            }

            if (account.iban) {
                name += `${account.iban} `
            }

            if (account.currency && account.currency !== 'XXX') {
                name += `(${account.currency})`
            }

            return name;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../../vue-embed/src/sass/reset.scss";
@import "../../../vue-embed/src/sass/_fonts.scss";
@import "../../../vue-embed/src/sass/_mixins.scss";
@import "../../../vue-embed/src/sass/_placeholders.scss";
@import "../../../vue-embed/src/sass/_payment-module.scss";

.bank-name-header {
    font-weight: bold;
    font-size: 18px;
    color: #324177;
}

.intro-text {
    color: #36457a;
}
</style>
